import { useEffect, useRef } from 'react'
import { updateWatchHistory } from '../../../actions/contentActions'
import {
  ComcastErrorType,
  triggerSentryError,
} from '../../../../../shared/helpers'

const THREE_MINUTES_TO_MS = 1000 * 60 * 3

async function sendWatchProgress(
  videoId: string,
  secondsWatched: number
): Promise<void> {
  try {
    await updateWatchHistory(videoId, secondsWatched)
  } catch (error) {
    triggerSentryError('updateWatchHistory', 'VideoPlayer.tsx', {
      errorMessage: error.message ?? 'Undefined error message (default)',
      videoId: videoId,
      secondsWatched,
      errorLocation: 'VideoPlayer - WatchHistoryError',
      errorType: ComcastErrorType.other,
    })
  }
}

export function useWatchProgress(
  videoId: string,
  getSecondsWatched: () => number
) {
  const savedCallback = useRef<() => number>()

  useEffect(() => {
    savedCallback.current = getSecondsWatched
  }, [getSecondsWatched])

  useEffect(() => {
    const id = setInterval(() => {
      if (savedCallback.current) {
        const secondsWatched = savedCallback.current()
        sendWatchProgress(videoId, secondsWatched)
      }
    }, THREE_MINUTES_TO_MS)
    return () => clearInterval(id)
  }, [])
}
